import React from 'react';
import { useIntl } from 'react-intl';
import { faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../common/views/SMLButton/SMLButton';
import { addSongMessages } from './addSongMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole page; each part uses its own slice of it */
import styles from './AddSongView.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface AddSongSaveBarProps {
  /** The song to add. Absent: the button says "Add my song" and stays off. */
  title?: string;
  canSave: boolean;
  note: string;
  onSave: () => void;
}

/** The Save row of both tabs (design c1, c2 `.ob-save`): "Add {title}" and one note. */
const AddSongSaveBarComponent: React.FC<AddSongSaveBarProps> = ({ title, canSave, note, onSave }) => {
  const intl = useIntl();
  const hasTitle = title !== undefined && title.trim() !== '';
  const label = hasTitle
    ? intl.formatMessage(addSongMessages.save, { title: title.trim() })
    : intl.formatMessage(addSongMessages.crumb);

  return (
    <div className={styles.saveBar}>
      <SMLButton
        color="primary"
        size="lg"
        omitCap
        rightIcon={faChevronRight}
        disabled={!canSave || !hasTitle}
        onClick={onSave}
        testID="add-song-save"
      >
        {label}
      </SMLButton>
      <span className={styles.tiny}>{note}</span>
    </div>
  );
};

export const AddSongSaveBar = TypedMemo(AddSongSaveBarComponent);
